import axios from "axios";
import { Dispatch, AnyAction } from "redux";
import AuthApi from "../api/authApi";
import { handleActionError } from "src/common/actions/actionErrorHandler";
import * as jwt_decode from "jwt-decode";
import { Token, tokenKey, LoginUser } from "../types/authentication";
import { handleAuthentication } from "../utilities/authHelper";
import { internalActionKeys } from "./internalActionKeys";

export const authenticateSuccess = (user: LoginUser): AnyAction => {
  return {
    type: internalActionKeys.AUTHENTICATE_SUCCESS,
    user
  };
};

export const internalLogout = (): AnyAction => {
  return {
    type: internalActionKeys.LOGOUT
  };
};

export const internalAuthenticate = (email: string, password: string) => {
  return async (dispatch: Dispatch) => {
    try {
      const response = await AuthApi.authenticate(email, password);
      if (response) {
        const token = jwt_decode<Token>(response);
        // SECURITY FIX: Removed client-side cookie storage as it cannot be HttpOnly
        // Client-side cookies are vulnerable to XSS attacks as they're accessible via JavaScript
        // Token is securely stored in sessionStorage and cleared when tab/window closes
        sessionStorage.setItem(tokenKey, response);
        axios.defaults.headers.common.Authorization = "Bearer " + response;
        handleAuthentication(token, dispatch);
      }
    } catch (error) {
      handleActionError(error, dispatch);
    }
  };
};
